// src/Constant.jsx

export const FONT_FAMILY = 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';
export const LINK_COLOR = '#111';
export const HOVER_BG = '#fff';
export const ACTIVE_BG = '#e5e7eb';
export const THEME_COLOR = '#111'; // Main theme color (used for header, buttons, etc)
export const SIDEBAR_BG = '#f6f6f7';
export const SIDEBAR_BORDER = '#e0e0e0';
